import { Routes, Route } from "react-router-dom";

import Navbars from "./components/navbar/Navbar";
import Hero from "./components/hero/Hero";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";

import Vastu from "./pages/Vastu";
import Astro from "./pages/Astro";
import Numerology from "./pages/Numerology";
import Prakriti from "./pages/Prakriti";
import Design from "./pages/Design";
import PalmistryAstro from "./pages/PalmistryAstro";

import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <>
      <Navbars />

      <Routes>
        {/* Home */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Contact />
            </>
          }
        />

        {/* Service pages */}
        <Route path="/vastu" element={<Vastu />} />
        <Route path="/astro" element={<Astro />} />
        <Route path="/numerology" element={<Numerology />} />
        <Route path="/prakriti" element={<Prakriti />} />
        <Route path="/design" element={<Design />} />
        <Route
          path="/palmistry-astro"
          element={<PalmistryAstro />}
        />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
